<!-- 差分強調表示凡例 -->
<div *ngIf="isDel || isDiff" class="c-flex-float-list c-flex-float-list-emp-ex">
  <div class="p-sub-column-layout02-flex">
    <dl class="p-payment-detailes-summary-block">
      <span>
        <img
          class="p-top-saved-plan__note-icon"
          src="{{ appConstants.IMG.R01_P040_S01_U__ICON_CHANGED_18 }}"
          width="18"
          height="18"
          alt
        />
      </span>

      <!-- WCAG規定により、凡例は読み上げ対象外 -->
      <span aria-hidden="true" [innerHTML]="'reader.diffIcon' | staticMsg"></span>
    </dl>
  </div>
</div>
<!-- サマリ本体 -->
<div class="c-flex-float-list" [ngClass]="{ 'delete-padding-top': isDel || isDiff }">
  <div class="p-sub-column-layout02-flex">
    <dl class="p-payment-detailes-summary-block">
      <div class="c-float-list01__item">
        <dt
          *ngIf="!paymentDetailsAwardData?.isAwardBooking"
          class="c-float-list01__title c-float-list01__title--em c-float-list01__contents--fs16 c-float-list01__title--gray90"
          [innerHTML]="'label.paymentTotalAmount' | staticMsg"
        ></dt>
        <!-- 提携：特典の場合マイルを表示 -->
        <dt
          *ngIf="paymentDetailsAwardData?.isAwardBooking"
          class="c-float-list01__title c-float-list01__title--em c-float-list01__contents--fs16 c-float-list01__title--gray90"
          [innerHTML]="'label.requiredMileage' | staticMsg"
        ></dt>
        <dd class="c-float-list01__contents c-float-list01__contents--fs24">
          <em [ngClass]="!isNone ? 'c-modified-element c-modified-element--has-icon' : ''">
            <span class="u-font-24" [ngClass]="{ del: isDel }">
              <!-- 支払総額 -->
              <span
                *ngIf="!paymentDetailsAwardData?.isAwardBooking"
                [innerHTML]="data.totalAmount | amountFormat : undefined : data.currencyCode"
              ></span>
              <!-- 提携：特典の場合マイルを表示 -->
              <span
                *ngIf="paymentDetailsAwardData?.isAwardBooking"
                [innerHTML]="paymentDetailsAwardData?.sumRequiredMiles ?? 0 | milesFormat : 'currencyUnit.MIL'"
              ></span>
              <span *ngIf="!isNone" class="c-modified-element__icon">
                <img
                  class="c-modified-element__icon-img"
                  src="{{ appConstants.IMG.R01_P040_S01_U__ICON_CHANGE_10 }}"
                  width="10"
                  height="10"
                  alt="変更箇所"
                />
              </span>
              <span *ngIf="!isNone" class="u-visually-hidden" [innerHTML]="'reader.diffIcon' | staticMsg"></span>
            </span>
          </em>
        </dd>
      </div>
      <div class="c-float-list01__item" *ngIf="paymentDetailsAwardData?.isAwardBooking">
        <dt
          class="c-float-list01__title c-float-list01__title--em c-float-list01__contents--fs16 c-float-list01__title--gray90"
          [innerHTML]="'label.paymentTotalAmount3' | staticMsg"
        ></dt>
        <dd class="c-float-list01__contents c-float-list01__contents--fs24">
          <em [ngClass]="!isNone ? 'c-modified-element c-modified-element--has-icon' : ''">
            <span class="u-font-24" [ngClass]="{ del: isDel }">
              <span [innerHTML]="data.totalTax | amountFormat : undefined : data.currencyCode"></span>
              <span *ngIf="!isNone" class="c-modified-element__icon">
                <img
                  class="c-modified-element__icon-img"
                  src="{{ appConstants.IMG.R01_P040_S01_U__ICON_CHANGE_10 }}"
                  width="10"
                  height="10"
                  alt="変更箇所"
                />
              </span>
              <span *ngIf="!isNone" class="u-visually-hidden" [innerHTML]="'reader.diffIcon' | staticMsg"></span>
            </span>
          </em>
        </dd>
      </div>
      <div class="c-float-list01__item">
        <dt class="c-float-list01__title"><!--見出しなし--></dt>
        <!--搭乗者種別毎の人数 -->
        <dd class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal">
          {{ data.travelersSummaryStr }}
        </dd>
      </div>
    </dl>
  </div>
  <div class="p-sub-column-layout02-flex p-payment-detailes-line-sp-only">
    <dl class="p-payment-detailes-summary-block">
      <div *ngIf="!(isCanada && data.totalFlightSurcharge)" class="c-float-list01__item">
        <!-- 運賃総額/マイル -->
        <dt
          *ngIf="!paymentDetailsAwardData?.isAwardBooking"
          class="c-float-list01__title"
          [innerHTML]="'label.fare' | staticMsg"
        ></dt>
        <dt
          *ngIf="paymentDetailsAwardData?.isAwardBooking"
          class="c-float-list01__title"
          [innerHTML]="'label.requiredMileage' | staticMsg"
        ></dt>
        <dd class="c-float-list01__contents">
          <span
            *ngIf="!paymentDetailsAwardData?.isAwardBooking"
            class="c-float-list01__contents--fs16 u-weight-bold"
            [innerHTML]="data.totalFare | amountFormat : undefined : data.currencyCode"
          ></span>
          <span
            *ngIf="paymentDetailsAwardData?.isAwardBooking"
            class="c-float-list01__contents--fs16 u-weight-bold"
            [innerHTML]="paymentDetailsAwardData?.sumRequiredMiles ?? 0 | milesFormat : 'currencyUnit.MIL'"
          ></span>
        </dd>
      </div>
      <div class="c-float-list01__item">
        <!-- 税金総額 -->
        <dt class="c-float-list01__title" [innerHTML]="'label.taxFare2' | staticMsg"></dt>
        <dd class="c-float-list01__contents">
          <span
            class="c-float-list01__contents--fs16 u-weight-normal"
            [innerHTML]="data.totalTax | amountFormat : undefined : data.currencyCode"
          ></span>
        </dd>
      </div>
      <div class="c-float-list01__item">
        <!-- 発券手数料 -->
        <dt class="c-float-list01__title" [innerHTML]="'label.fee' | staticMsg"></dt>
        <dd class="c-float-list01__contents">
          <!-- ※固定値0を出力 -->
          <span
            class="c-float-list01__contents--fs16 u-weight-normal"
            [innerHTML]="0 | amountFormat : undefined : data.currencyCode"
          ></span>
        </dd>
      </div>
    </dl>
  </div>
</div>

<div *ngIf="data.alertLabelTxt.length !== 0" class="p-alert-label-txt">
  <div *ngFor="let str of data.alertLabelTxt" class="p-alert-label-txt_content">
    <em class="p-alert-label-txt_content_txt" [innerHTML]="str | staticMsg"></em>
  </div>
</div>
